import CrudResource from "@/components/CrudResource";

export default function Spareparts() {
  return (
    <CrudResource
      title="Sparepart Servis"
      subtitle="Stok bahan servis (LCD, baterai, backglass, dll)"
      endpoint="/spareparts"
      columns={[
        { key: "name", label: "Nama Sparepart" },
        { key: "category", label: "Kategori" },
        { key: "stock", label: "Stok", render: (r) => (
          <span className={r.stock <= (r.min_stock || 0) ? "text-red-600 font-medium" : ""}>{r.stock}</span>
        ) },
        { key: "cost_price", label: "Modal", money: true },
        { key: "sell_price", label: "Jual", money: true },
      ]}
      fields={[
        { name: "name", label: "Nama Sparepart", required: true, full: true },
        { name: "category", label: "Kategori", type: "select", default: "Umum",
          options: ["LCD", "Baterai", "Body", "Konektor", "Kamera", "Umum"] },
        { name: "stock", label: "Jumlah Stok", type: "number" },
        { name: "min_stock", label: "Stok Minimum", type: "number", default: 1 },
        { name: "cost_price", label: "Harga Modal", type: "number" },
        { name: "sell_price", label: "Harga Jual", type: "number" },
      ]}
    />
  );
}
